import { useRouter } from '@application/utils';
import type { FC } from 'react';
import { Container } from '../Container';
import * as Styled from './styled';
import type { AwarenessBannerProps } from './types';

export const AwarenessBanner: FC<AwarenessBannerProps> = (props) => {
  const { onClick } = props;
  const { translate } = useRouter();

  return (
    <Styled.Background>
      <Container>
        <Styled.Flex>
          <Styled.Content>
            <Styled.Title>{translate('common.banners.animals.title')}</Styled.Title>
            <Styled.Subtitle>{translate('common.banners.animals.text')}</Styled.Subtitle>
            <Styled.ButtonStyled color="light" outlined onClick={onClick}>
              {translate('common.buttons.readAdvice')}
            </Styled.ButtonStyled>
          </Styled.Content>
        </Styled.Flex>
      </Container>
    </Styled.Background>
  );
};
